import messages from "./en.json";
export const dateFormat = {
  en: {
    "event-overview": "Do MMM",
    "report-date": "DD/MM/YYYY HH:mm",
    "date-DD/MM/YYYY": "DD/MM/YYYY",
    "time-HH:mm": "HH:mm",
    "date-DD/MM": "M/DD",
  },
};
export const message = {
  en: messages,
};
